import cn from 'classnames';
import { GridProps, SpacingBreakpoints } from './interfaces';
import { generateColClassNames } from './utils';
import styles from './grid.module.scss';

const defaultSpacing: SpacingBreakpoints = {
    sm: 40,
    lg: 48,
    xl: 56,
};

export const Grid = ({ ...props }: GridProps): React.JSX.Element => {
    const spacing = props.standardAtomSpacing ? defaultSpacing : props.spacing;

    const classNames = cn(props.className, {
        [styles['grid-container']]: props.container,
        [styles.col]: !props.container,
        [styles['standard-molecule-spacing']]: props.standardMoleculeSpacing,
        [styles[`align-${props.container ? `items` : `self`}-${props.align}`]]: props.align,
        ...generateColClassNames('col', props.col),
        ...generateColClassNames('col-start', props.start),
        ...generateColClassNames('grid-row-gap', spacing),
        ...generateColClassNames('col-order', props.order),
        [styles['no-padding']]: props.noPadding,
        [styles['no-mobile-padding']]: props.noMobilePadding,
    });

    return (
        <div
            className={classNames}
            data-index={props.dataIndex}
            data-cy={props.dataCy}
            {...(props.ignoreInChromatic ? { 'data-chromatic': 'ignore' } : {})}
        >
            {props.children}
        </div>
    );
};
